import React from "react";

interface SuccessDialogProps {
  visible: boolean;
  onClose: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({ visible, onClose }) => {
  if (!visible) return null; // Hide when not visible

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black/40 z-50 backdrop-blur-lg'>
      <div className='bg-white rounded-2xl shadow-xl p-8 max-w-sm w-full text-center'>
        {/* Icon */}
        <div className='mx-auto mb-4 w-20 h-20 flex items-center justify-center rounded-full bg-[#F3943F]/10'>
          <svg
            className='w-10 h-10 text-[#F3943F]'
            fill='none'
            stroke='currentColor'
            strokeWidth={2.5}
            viewBox='0 0 24 24'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M5 13l4 4L19 7'
            />
          </svg>
        </div>

        {/* Title */}
        <h2 className='text-xl font-semibold mb-2 text-gray-900'>
          Form submitted successfully
        </h2>

        {/* Message */}
        <p className='text-gray-600 mb-6'>
          Your form has been shared with the landlord. If you're a good match,
          they'll get in touch with you.
        </p>

        {/* Close Button */}
        <button
          onClick={onClose}
          className='w-full bg-[#F3943F] text-white py-2 rounded-lg hover:opacity-90 transition'>
          Close
        </button>

        {/* Footer */}
        <div className='mt-6 text-sm text-gray-500'>
          <p>
            Created using{" "}
            <a href='/' className='text-[#F3943F]'>
              HomeOwner App
            </a>
          </p>
          <div className='mt-2 flex justify-center gap-4'>
            <a href='/about' className='hover:underline'>
              About HomeOwner
            </a>
            <a href='/policy' className='hover:underline'>
              Privacy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessDialog;
